'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21.176 21h-9.14v-.665h8.605l-3.438-6.958h-6.419v-.665h6.625c.126 0 .242.072.298.185l3.767 7.623a.332.332 0 0 1-.298.48",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.785 20.335V21h-.665v-.665h.665Zm-4.939 0V21H4.422v-.665h1.424Zm2.849 0V21H7.271v-.665h1.424Zm-6.366-.411.596.295-.058.116h.13V21h-.665a.331.331 0 0 1-.298-.48l.295-.596Zm8.161-3.147c.16 0 .294.114.325.266l.007.067v1.648h1.213v.665H4.64v-.665h1.213V17.11c0-.161.113-.295.265-.326l.067-.007h4.305Zm-6.89.575.596.294-.635 1.286-.596-.294.635-1.286Zm6.557.09h-3.64v1.316h3.64v-1.316Zm-5.285-2.663.596.295-.636 1.286-.596-.294.636-1.287Zm13.744-8.607c.16 0 .294.115.325.266l.007.067v1.782a.333.333 0 0 1-.265.326l-.067.007H10.03l.01 7.492h-.665l-.002-1.72h-1.88l1.346 1.58-.337.289L7.3 14.849 7.3 16.11l-.664.002-.01-7.493H3.361a.332.332 0 0 1-.325-.266l-.007-.067V6.505c0-.16.113-.295.265-.326l.067-.006h15.255Zm-9.248 5.714L7.51 13.949h1.861l-.003-2.063Zm-3.566 1.01.596.296-.295.596-.596-.295.295-.596Zm3.363-1.446h-1.87l.002 2.073 1.868-2.072ZM7.291 8.93l.003 2.078h1.871L7.291 8.928Zm2.073-.31H7.61l1.757 1.95-.003-1.95Zm7.863-1.474-1.06.81h2.116v-.003l-1.056-.808ZM3.693 7.4v.554h.726L3.693 7.4Zm10.758-.256-1.058.81h2.118l-1.06-.81Zm-2.773 0-1.059.81h2.118l-1.059-.81Zm-2.773 0-1.059.81h2.118l-1.059-.81Zm-2.773 0-1.057.81h2.116l-1.059-.81Zm-.327-.306H3.693v.003l1.054.806 1.058-.81Zm11.094 0h-2.12l1.06.81 1.06-.81Zm-2.775 0h-2.118l1.06.81 1.058-.81Zm-2.773 0H9.233l1.06.81 1.058-.81Zm-2.774 0H6.46l1.058.81 1.06-.81Zm9.706 0h-.728l.728.556v-.556ZM8.121 3l.08.015 6.968 2.251-.204.633-6.804-2.198L5.34 5.848l-.402-.529 2.96-2.251a.329.329 0 0 1 .145-.063L8.122 3Z",
    fill: "#3F3E4B"
  })));
});
var FwSet0CultivableLimited = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0CultivableLimited = FwSet0CultivableLimited;